module.exports = "/static/viewer/generated/images/Blue EDAR Logo Only.png?a4ce2e682b609e4b12fb11cfb4233cf3";